import { AnyAction, combineReducers } from "@reduxjs/toolkit";
import businessApi from "store/apis/businessApi";
import businessListApi from "store/apis/businessListApi";
import userApi from "store/apis/userApi";
import businessReducer from "store/slices/businessSlice";
import topUpHistoryReducer from "store/slices/topUpHistorySlice";

const combinedReducer = combineReducers({
  businesses: businessReducer,
  topUpHistory: topUpHistoryReducer,
  [businessListApi.reducerPath]: businessListApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [businessApi.reducerPath]: businessApi.reducer,
});

export const RootActions = {
  RESET_STORE: "RESET_STORE",
};

export const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === RootActions.RESET_STORE) {
    state = {};
  }
  return combinedReducer(state, action);
};
